import React from 'react';

import { formatCurrency } from '../utils/format';

const ASSETS_BASE_URL = process.env.REACT_APP_MTN_IMG_BASE_URL;

const buildImageUrl = (imagePath = '') => {
  if (!imagePath) {
    return '';
  }

  if (/^https?:\/\//i.test(imagePath)) {
    return imagePath;
  }

  const sanitizedPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;

  try {
    return new URL(sanitizedPath, ASSETS_BASE_URL).href;
  } catch (e) {
    console.warn(e);
    return `/${sanitizedPath}`;
  }
};

function ProductCard({ product }) {
  if (!product) {
    return null;
  }

  const brandName = product.brandName || "Marca disponible";
  const productName = product.name || "Producto";
  const priceLabel = product.price
    ? formatCurrency(product.price)
    : "Consultar";
  const imageUrl = buildImageUrl(product.image);

  const goProductDetails = () => {
    window.open(
      `https://detittamotos.com.ar/detalles/Motos/${brandName}/${productName}/${product.id}`,
      "_blank"
    );
  };

  return (
    <div
      onClick={goProductDetails}
      role="button"
      className="bg-white mb-2 rounded-3 border-2 border-light shadow-sm overflow-hidden"
    >
      <div className="d-flex justify-content-between align-items-start gap-2 p-3 pb-0">
        <p
          className="text-uppercase fw-semibold mb-0"
          style={{ color: "var(--color-text-secondary)", fontSize: "0.85rem" }}
        >
          {brandName}
        </p>
        <p className="fw-bold mb-0" style={{ color: "var(--color-accent)" }}>
          {priceLabel}
        </p>
      </div>
      <div className="ratio ratio-16x9 bg-white d-flex align-items-center justify-content-center">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={`${brandName} ${productName}`.trim()}
            className="w-100 h-100"
            style={{ objectFit: "contain" }}
            loading="lazy"
          />
        ) : (
          <span className="text-muted small">Sin imagen disponible</span>
        )}
      </div>
      <div className="p-3">
        <p className="fw-bold mb-0" style={{ color: "var(--color-heading)" }}>
          {productName}
        </p>
      </div>
    </div>
  );
}

export default ProductCard;
